import Tooltip from '../../../../../UI/Tooltip/Tooltip'
import ChartSelector, { ChartType } from './ChartSelector'
import { Props } from './types'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid'

const Core: React.FC<
  Props<any, any> & { small?: boolean; availableChartOptions?: ChartType[]; activeChart?: ChartType; setActiveChart?: (type: ChartType) => void }
> = ({ element, small, availableChartOptions, activeChart, setActiveChart }) => {
  return (
    <div>
      <ChartSelector availableOptions={availableChartOptions} activeChart={activeChart} setActiveChart={setActiveChart} />
      {!!element.title && (
        <div>
          <div className={`flex items-center gap-1 ${small ? 'text-lg' : 'text-xl font-bold'}`}>
            {element.title}
            {!!element.helpText && (
              <Tooltip text={element.helpText} className="hidden md:inline-block">
                <QuestionMarkCircleIcon className="w-5 fill-cyan" />
              </Tooltip>
            )}
          </div>
          {!!element.helpText && <div className="md:hidden text-sm text-gray">{element.helpText}</div>}
        </div>
      )}
      {!!element.description && (
        <div className={`text-gray whitespace-pre-wrap ${!!element.title && !small && 'mt-3'} ${small && 'text-sm'}`}>{element.description}</div>
      )}
    </div>
  )
}

export default Core
